@if (!AccessAllowed && CompletedLoading) {
  <div>
    <h3 style="border: 2px solid;border-radius: 6px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);padding: 10px;">You don't have access to this function</h3>
  </div>
}

@if (AccessAllowed) {
  <div class="p-3 flex flex-column flex-auto cf-page" [class.cf-compact]="isMobile">
    <div>
      <div class="text-900 font-medium text-xl mb-3">
        <h3>Upgrade - {{upgrade.name}}</h3>
      </div>
      <p class="m-0 mb-4 p-0 text-600 line-height-3 mr-3">
        <span class="pi pi-info-circle" style="margin-right:2px;"></span>
      </p>
      <div class="surface-card p-4 shadow-2 border-round">
        <div class="grid formgrid p-fluid">
          <div class="field mb-4 col-12">
            <label for="upgradename" class="font-medium">Name</label>
            <div style="clear:both;"></div>
            <input [(ngModel)]="upgrade.name" [ngStyle]="{'border-color': (upgradeNameValid==false) ? '#FF0000':''}" id="upgradename" type="text" pInputText>
          </div>
          @if (!upgradeNameValid) {
            <div class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter an Upgrade Name.</div>
          }
          <div class="field mb-4 col-12">
            <label for="upgradedescription" class="font-medium">Description</label>
            <p-editor [(ngModel)]="upgrade.description" [style]="{'height':'320px'}">
              <ng-template #header>
                <span class="ql-formats">
                  <p-header>
                    <span class="ql-formats">
                      <select class="ql-size">
                        <option value="small">Small</option>
                        <option selected value="normal">Normal</option>
                        <option value="large">Sub Heading</option>
                        <option value="huge">Heading</option>
                      </select>
                      <select class="ql-font">
                        <option selected value="san serif">San-Serif</option>
                        <option value="monospace">Monospace</option>
                        <option value="serif">Serif</option>
                      </select>
                    </span>
                    <span class="ql-formats">
                      <button class="ql-bold" aria-label="Bold"></button>
                      <button class="ql-italic" aria-label="Italic"></button>
                      <button class="ql-underline" aria-label="Underline"></button>
                      <button class="ql-strike" aria-label="Strike"></button>
                      <button class="ql-script" value="sub" title="Subscript"></button>
                      <button class="ql-script" value="super" title="Superscript"></button>
                      <button class="ql-indent" value="-1" title="Indent"></button>
                      <button class="ql-indent" value="+1" title="Outdent"></button>
                    </span>
                    <span class="ql-formats">
                      <select title="Text Color" class="ql-color" defaultValue="rgb(0, 0, 0)">
                      </select>
                      <span class="ql-format-separator"></span>
                      <select title="Background Color" class="ql-background" defaultValue="rgb(255, 255, 255)">
                      </select>
                    </span>
                    <span class="ql-formats">
                      <button class="ql-list" title="Ordered" value="ordered"></button>
                      <button class="ql-list" title="Bullet" value="bullet"></button>
                      <select title="Text Alignment" class="ql-align" >
                        <option label="Left"></option>
                        <option value="center" label="Center"></option>
                        <option value="right" label="Right"></option>
                        <option value="justify" label="Justify"></option>
                      </select>
                    </span>
                    <span class="ql-formats">
                      <button aria-label="Link" class="ql-link"></button>
                    </span>
                  </p-header>
                </span>
              </ng-template>
            </p-editor>
          </div>
          @if (!upgradeDescValid) {
            <div class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter an Upgrade Description.</div>
          }
          <div style="clear:both;width:100%">&nbsp;</div>
          <div class="field mb-4 col-12">
            <label for="upgradeFile" class="font-medium">Upload a header image for Booking Wizard. The image must be smaller than 100KB</label>
            <div style="clear:both;width:100%">&nbsp;</div>
            <p-fileupload style="float:left;margin-right:10px;" mode="basic" [auto]="true" name="image" url="{{HTMLbmxurl}}/imageupload/{{VenueID}}/{{Identifier}}" accept="image/*" maxFileSize="100000" (onUpload)="uploadedFile($event)" (onError)="onErrorFileUpload($event)" chooseLabel="Upload File"></p-fileupload>
            @if (FileChosen != null && FileChosen != '') {
              <button pButton pRipple type="button" style="float: left;margin-bottom: 10px;margin-top: 1px !important;height: 50px;" class="p-button-sm p-element p-button-danger w-auto mt-3" (click)="removeImage()">
                <span style="margin-right:10px;" class="pi pi-times"></span>
                Remove Image
              </button>
            }
            <div style="clear:both;width:100%">&nbsp;</div>
            @if (FileChosen != null && FileChosen != '') {
              <div>
                <p style="margin-top:10px;">This is how your image will look in place.</p>
                <div class="surface-card p-4 shadow-2 border-round upgradeCard" style="width: 460px;">
                  <div id="image">
                    <img src="{{ FileChosen }}" style="width: 460px;margin-top: -23px;margin-left: -23px;margin-right: -23px;">
                  </div>
                  <div style="font-weight: bold; padding: 20px;font-size:larger;">{{upgrade.name}}</div>
                  <div style="padding-left: 20px; padding-right: 20px" [innerHTML]="">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum
                  </div>
                  <div>
                    <br><br>
                  </div>
                  <div>
                    <div>
                      <p-button label="Add this Upgrade" icon="pi pi-check" style="width:420px;">
                      </p-button>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
          <div class="surface-card p-4 shadow-2 border-round" style="width:100%;float:left;">
            @if (!isMobile) {
              <div style="float:left; width:32%">
                <div class="drag-column">
                  <h5> Available Resources </h5>
                  <p-table [value]="availableResources">
                    <ng-template #header>
                      <tr>
                        <th style="width:90%">Name</th>
                        <th>&nbsp;</th>
                        <th>&nbsp;</th>
                      </tr>
                    </ng-template>
                    <ng-template #body let-resource>
                      <tr>
                        @if (!resource.isresourcecontainer) {
                          <td><span class="pi pi-stop" style="margin-right: 10px;"></span>{{resource.name}}</td>
                        }
                        @if (resource.isresourcecontainer && !resource.isconstructed) {
                          <td><span class="pi pi-clone" style="margin-right: 10px;"></span>{{resource.name}}</td>
                        }
                        @if (resource.isresourcecontainer && resource.isconstructed) {
                          <td><span class="pi pi-sitemap" style="margin-right: 10px;"></span>{{resource.name}}</td>
                        }
                        <td>&nbsp;</td>
                        <td>
                          <button pButton pRipple type="button" class="p-button-sm p-element p-button-success w-auto mt-3" (click)="AddToResources(resource)">
                            <span class="pi pi-angle-right"></span>
                          </button>
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </div>
            }
            <div class="cf-col" style="float:left; width:65%">
              <div class="col-12 md:col-12 drop-column" pDroppable="resources">
                <!-- On a phone the Available list is this dropdown instead - see addPicked. -->
                @if (isMobile) {
                  <div class="cf-add-row">
                    <p-select [options]="availableResources" [(ngModel)]="picked['resources']" [ngModelOptions]="{standalone: true}" optionLabel="name" placeholder="Add a resource"
                    [filter]="true" filterBy="name" appendTo="body" emptyMessage="None available"></p-select>
                    <button pButton pRipple type="button" class="p-button-success"
                      [disabled]="picked['resources'] == null" (click)="addPicked('resources', AddToResources)"><span class="p-button-icon p-button-icon-left pi pi-plus" aria-hidden="true"></span><span class="p-button-label">Add</span></button>
                    </div>
                  }
                  <h5> Selected Resources </h5>
                  <p-table styleClass="cf-panel-list" [value]="upgrade.resources">
                    <ng-template #body let-resource let-columns="columns" let-index="rowIndex">
                      <tr [pReorderableRow]="index">
                        <td class="cf-handle">
                          <span class="pi pi-bars" pReorderableRowHandle></span>
                        </td>
                        <td>
                          <app-accordion style="background-color: white !important; margin-top: 5px; border: none;" expandIcon="pi pi-chevron-right" collapseIcon="pi pi-chevron-down">
                            <app-accordiontab style="background-color: white !important; margin-top: 5px; border: none;">
                              <ng-template pTemplate="header">
                                @if (!resource.isresourcecontainer) {
                                  <div style="width:100%">
                                    <span class="pi pi-stop" style="margin-right: 10px;"></span>{{resource.name}}&nbsp;(Length:{{resource.length}}&nbsp;{{resource.exclusive? ", Exclusive": ""}})
                                  </div>
                                }
                                @if (resource.isresourcecontainer && !resource.isconstructed) {
                                  <div style="width:100%">
                                    <span class="pi pi-clone" style="margin-right: 10px;"></span>{{resource.name}}
                                  </div>
                                }
                                @if (resource.isresourcecontainer && resource.isconstructed) {
                                  <div style="width:100%">
                                    <span class="pi pi-sitemap" style="margin-right: 10px;"></span>{{resource.name}}
                                  </div>
                                }
                              </ng-template>
                              <div class="surface-card p-4 shadow-2 border-round">
                                <div class="grid formgrid p-fluid">
                                  <div class="field mb-4 col-12">
                                    <label for="selectionmode" class="font-medium">Mode:</label>
                                    <p-selectbutton id="selectionmode" [options]="stateOptionsComplexSimple" [(ngModel)]="resource.mode" ></p-selectbutton>
                                  </div>
                                  <div class="field mb-4 col-12">
                                    <label for="selectionmode" class="font-medium">Length:</label>
                                    <p-inputnumber inputId="rlen{{index}}" [(ngModel)]="upgrade.resources[index].length" [showButtons]="true" mode="decimal" buttonLayout="horizontal"></p-inputnumber>
                                  </div>
                                  <div class="field mb-4 col-12">
                                    <label for="selectionmode" class="font-medium">Exclusivity:</label>
                                    <p-selectbutton  [options]="stateOptionsRes" [(ngModel)]="upgrade.resources[index].exclusive"></p-selectbutton>
                                  </div>
                                  @if (resource.mode=='COMPLEX') {
                                    <div>
                                      @if (resource.isconstructed) {
                                        <div>
                                          <div class="field mb-4 col-12">
                                            <label for="selectionmode" class="font-medium">Select if the customer selects from a list or any of the available resources or if the system chooses it for them.</label>
                                            <p-selectbutton id="selectionmode" class="cf-stack" [options]="stateOptionsSel" [(ngModel)]="resource.selectionmode" ></p-selectbutton>
                                          </div>
                                          @if (resource.selectionmode == 'LIST' || resource.selectionmode == 'SYSTEMLIST') {
                                            <div class="field mb-4 col-12">
                                              <label for="selectionmode" class="font-medium">Choose Selectable Resourses</label>
                                              <p-table [value]="resource.resources"
                                                [(selection)]="resource.selectableresourcestrings" dataKey="resourceId">
                                                <ng-template #header>
                                                  <tr>
                                                    <th>&nbsp;</th>
                                                    <th style="width: 40%;">Name</th>
                                                    <th style="width: 27%;">&nbsp;</th>
                                                    <th style="width: 33%;">&nbsp;</th>
                                                  </tr>
                                                </ng-template>
                                                <ng-template #body let-selResources>
                                                  <tr>
                                                    <td>
                                                      <p-tablecheckbox [value]="selResources"></p-tablecheckbox>
                                                    </td>
                                                    <td>
                                                      {{selResources.name}}
                                                    </td>
                                                    <td>
                                                      <!--<p-inputnumber inputId="rlen{{index}}"[(ngModel)]="selResources.length" [showButtons]="true" mode="decimal" buttonLayout="horizontal"></p-inputnumber>-->
                                                    </td>
                                                    <td>
                                                      <!--<p-inputnumber inputId="rprice{{index}}" [(ngModel)]="selResources.price" [showButtons]="true" mode="currency" currency="{{CurrencySymbol}}" buttonLayout="horizontal"></p-inputnumber>-->
                                                    </td>
                                                  </tr>
                                                </ng-template>
                                              </p-table>
                                            </div>
                                          }
                                        </div>
                                      }
                                      <div class="field mb-4 col-12">
                                        <label for="ResourceStart" class="font-medium">Is this resource offset? (does it run at the sametime as other resources but may start a number of minutes after the start of the booking)</label>
                                        <p-selectbutton id="ResourceStart"  [options]="stateOptionsBool" [(ngModel)]="resource.inline" ></p-selectbutton>
                                      </div>
                                      @if (!resource.inline) {
                                        <div>
                                          <div class="field mb-4 col-12">
                                            <label for="ResourceStart" class="font-medium">When does this Resource start? ('At Start' will start this resource at the start of the booking, 'At End' will start this resource at the end of the booking and Offset will start the resource a number of minutes either negative or positive after the start of the booking e.g -10 minutes would start the resource 10 minutes before the booking starts.)</label>
                                            <p-selectbutton id="ResourceStart"  [options]="stateOptionsStart" [(ngModel)]="resource.startwhen"></p-selectbutton>
                                          </div>
                                          @if (resource.startwhen == 'OFFSET') {
                                            <div class="field mb-4 col-12">
                                              <label for="quantity" class="font-medium">Offset in number of minutes</label>
                                              <p-inputnumber id="quantity" [ngModel]="resource.startTimeOffset== null ? 1: resource.startTimeOffset" (ngModelChange)="resource.startTimeOffset = $event" [showButtons]="true" max="420" min="-420" buttonLayout="horizontal" spinnerMode="horizontal"></p-inputnumber>
                                            </div>
                                          }
                                          @if (resource.startwhen != 'OFFSET') {
                                            <div class="field mb-4 col-12">
                                              <label style="display:none;" for="quantity" class="font-medium">Offset in number of minutes</label>
                                              <p-inputnumber style="display:none;" id="quantity" [ngModel]="resource.startTimeOffset== null ? 1: resource.startTimeOffset" (ngModelChange)="resource.startTimeOffset = $event" [showButtons]="true" max="420" min="-420" buttonLayout="horizontal" spinnerMode="horizontal"></p-inputnumber>
                                            </div>
                                          }
                                        </div>
                                      }
                                      <div class="field mb-4 col-12">
                                        <label for="ResourceOpt" class="font-medium">Is this Resource optional?</label>
                                        <p-selectbutton id="ResourceOpt"  [options]="stateOptions" [(ngModel)]="resource.optional" ></p-selectbutton>
                                      </div>
                                      <div class="field mb-4 col-12">
                                        <label for="QuantityMode" class="font-medium">Will this resource be for the whole group, just those participating or should the customer choose</label>
                                        <p-selectbutton id="QuantityMode"  [options]="stateOptionsQty" [(ngModel)]="resource.quantityselector" ></p-selectbutton>
                                      </div>
                                      <!--<div *ngIf="resource.quantityselector !='GROUPSIZE' && resource.quantityselector !='PARTICIPANT'" class="field mb-4 col-12">
                                      <label for="quantity" class="font-medium">Quantity</label>
                                      <p-inputnumber id="quantity" [(ngModel)]="resource.quantity== null ? 1: resource.quantity" [showButtons]="true" max="999" min="1" buttonLayout="horizontal" spinnerMode="horizontal"></p-inputnumber>
                                    </div>-->
                                    <div style="display:none">
                                      <div class="field mb-4 col-12">
                                        <label for="quantity" class="font-medium">Price:</label>
                                        <p-inputnumber  [(ngModel)]="resource.price" [showButtons]="true" buttonLayout="horizontal" mode="currency" currency="{{CurrencySymbol}}"></p-inputnumber>
                                      </div>
                                      <div class="field mb-4 col-12">
                                        <label for="QuantityMode" class="font-medium">Is this price fixed or per person?</label>
                                        <p-selectbutton id="PriceMode"  [options]="stateOptionsPrice" [(ngModel)]="resource.fixedprice" ></p-selectbutton>
                                      </div>
                                    </div>
                                  </div>
                                }
                              </div>
                            </div>
                          </app-accordiontab>
                        </app-accordion>
                      </td>
                      <td>
                        <button pButton pRipple type="button" [style]="{'margin-bottom': '10px'}" class="p-button-sm p-element p-button-danger w-auto mt-3" (click)="removeFromResources(resource)">
                          <span class="pi pi-angle-left"></span>
                        </button>
                      </td>
                      <td class="row-move-cell"><app-row-move [list]="upgrade.resources" [index]="index"></app-row-move></td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12">
        <button pButton pRipple type="button" class="p-button p-element p-button-success w-auto mt-3" (click)="updateData()"><span class="pi pi-pencil" style="margin-right:8px;"></span> Save Changes </button> &nbsp;
        <button pButton pRipple type="button" class="p-button p-element p-button-danger w-auto mt-3" (click)="returnToList()"> <span class="pi pi-times" style="margin-right:8px;"></span> Cancel </button>
      </div>
    </div>
    <style>
      :host ::ng-deep .p-chip.custom-chip {
      background: var(--primary-color);
      color: var(--primary-color-text);
    }
  </style>
  <!-- Closes the outer div, which was left open (Angular closed it implicitly here) -->
</div>
}
